import React from 'react';
import { FileText } from 'lucide-react';

const Report = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <FileText size={32} className="page-icon" />
        <h1 className="page-title">Reports</h1>
      </div>
      <div className="page-content">
        <p className="page-description">Generate and view various reports.</p>
        {/* Report module content will go here */}
      </div>
    </div>
  );
};

export default Report;